import axiosClient from "api";
import React, { useEffect, useRef, useState } from "react";

import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Box, Checkbox, Tab, Tabs } from "@mui/material";
import api from "api";

import PortfolioImageUpload from "../../component/portfolioImageUpload";
import CertificationImageUpload from "../../component/certificationImageUpload";
import { toastify, toastType } from "util/toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-regular-svg-icons";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ServiceDetailList({ user, defaultServiceId, setDeletedService }) {
  const [services, setServices] = useState([]);
  const [activeServiceId, setActiveServiceId] = useState(+defaultServiceId || 0);
  const [, setActiveService] = useState(null);
  const [portfolioList, setPortfolioList] = useState([]);
  const [certificationList, setCertificationList] = useState([]);
  const rateRef = useRef(null);
  useEffect(() => {
    user && setServices(user.services);
  }, [user]);

  useEffect(() => {
    if (
      user &&
      user.services &&
      user.services.length > activeServiceId &&
      user.services[activeServiceId].UserService &&
      user.services[activeServiceId].UserService.id
    ) {
      axiosClient
        .get(`/api/service/${user.services[activeServiceId].UserService.id}`)
        .then((res) => {

          const serviceData = res.data.data.data

          setActiveService(serviceData)

          setServices((prev) => {
            const updated = [...prev];
            updated[activeServiceId] = {
              ...updated[activeServiceId],
              UserService: {
                ...updated[activeServiceId].UserService,
                // Use fresh data from API response
                experience: serviceData.experience,
                requireCertifications: serviceData.requireCertifications,
                requireWorkSamples: serviceData.requireWorkSamples,
              },
              title: serviceData.service.title,
              type: serviceData.service.type,
            }
            return updated
          })
          setPortfolioList(serviceData.portfolio || [])
          setCertificationList(serviceData.certification || [])
        })
        .catch((err) => {
          console.error(err)
          toastify("Internal Server Error(s)", toastType.error)
        });
    } else {
      // Optional: clear or reset data to avoid stale UI
      setCertificationList([])
      setPortfolioList([])
      setActiveService(null)
      console.warn("Service or UserService.id not available yet")
    }
  }, [user, activeServiceId])

  const deleteHandler = () => {
    axiosClient
      .delete(`/api/service/${user.services[activeServiceId].UserService.id}`)
      .then((res) => {
        // history.push("/my-profile");
        setDeletedService(state => !state)
        setActiveServiceId(0)
        toastify("Your Service deleted Successfully.", toastType.success);
      })
      .catch((err) => {
        console.error(err);
        toastify(
          err?.response?.data?.message || "Failed To Delete Your Service.",
          toastType.error
        );
      });
  };

  const tabHandleChange = (event, newValue) => {
    setActiveServiceId(newValue);
  };

  const changeTitle = (value) => {
    let tmp = [...services];
    tmp[activeServiceId].title = value;
    setServices(tmp);
  };

  const changeExperience = (experienceText) => {
    let tmp = JSON.parse(JSON.stringify(services));
    tmp[activeServiceId].UserService.experience = experienceText;
    setServices(tmp);
  };
  const changeDetail = (detailText) => {
    let tmp = JSON.parse(JSON.stringify(services))
    tmp[activeServiceId].UserService.detail = detailText
    setServices(tmp)
  }

  const changeRate = (rate) => {
    let tmp = JSON.parse(JSON.stringify(services))
    tmp[activeServiceId].UserService.rate = rate
    rateRef.current.value = rate
    setServices(tmp)
  }

  const changeType = (detail) => {
    let tmp = [...services];
    tmp[activeServiceId].type = detail;
    setServices(tmp);
  };

  const updateServiceDetail = () => {
    axiosClient
      .post("/api/users/update-detail", {
        serviceId: services[activeServiceId].id,
        // userId lives on the UserService join row, not the top-level Service.
        userId: services[activeServiceId].UserService.userId,
        userserviceId: services[activeServiceId].UserService.id,
        title: services[activeServiceId].title,
        experience: services[activeServiceId].UserService.experience,
        detail: services[activeServiceId].UserService.detail,
        rate: services[activeServiceId].UserService.rate,
        type: services[activeServiceId].type,
      })
      .then((_res) => {
        toastify("Service Detail is updated.", toastType.success);
      })
      .catch((err) => {
        console.error(err);
        toastify("Updating Service Detail is Failed.", toastType.error);
      });
  };

  const changeFieldRequirement = async (field, value) => {
    let tmp = [...services];
    if (field === "certification") {
      services[activeServiceId].UserService.requireCertifications = value;
    }
    if (field === "portfolio") {
      services[activeServiceId].UserService.requireWorkSamples = value;
    }
    await axiosClient.post("/api/service/update-requirement", {
      serviceId: services[activeServiceId].id,
      field,
      value,
    });
    setServices(tmp);
  };

  return (
    <div className="service-detail-list mt-2">
      <div className="sm:grid sm:grid-cols-4 sm:gap-4">
        <Box
          flexDirection={"column"}
        >
          <Tabs
            value={activeServiceId}
            onChange={tabHandleChange}
            aria-label="service detail tabs"
            className="service-nav max-sm:mb-2"
            indicatorColor="transparent"
          >
            {services.map((service, index) => (
              <Tab
                key={`service-title-${index}`}
                label={service.title}
                className="w-full max-sm:!max-w-full text-left mb-1"
                {...a11yProps(index)}
              />
            ))}
          </Tabs>
        </Box>
        <div className="col-span-3">
          <div className="edit-tab-content pb-10" sx={{ width: "100%" }}>
            {services.length > 0 ? (
              services.map((service, index) => (
                <TabPanel
                  key={`service-detail-${index}`}
                  value={activeServiceId}
                  index={index}
                >
                  <div className="edit-tab-panel">
                    <Stack>
                      <Item className="mb-6">
                        {/* <button
                          onClick={deleteHandler}
                          className="group absolute right-[26rem] top-96 border-none bg-transparent transition-all duration-300"
                        >
                          <FontAwesomeIcon
                            className="group-hover:!text-[#BE123C]"
                            icon={faTrashAlt}
                            style={{ fontSize: 23, color: "#000" }}
                          />
                        </button>
                        <h3 className="mt-[50px] mb-[26px] font-bold">
                          Service Title
                        </h3> */}


                        <div className="relative flex items-center justify-center mb-6 mt-10">
                          <h3 className="font-bold text-lg sm:text-xl md:text-2xl text-center">
                            Service Title
                          </h3>
                          {services.length > 1 && (
                            <button
                              onClick={deleteHandler}
                              className="group absolute right-0 sm:right-4 md:right-8 bg-transparent border-none transition-all duration-300"
                            >
                              <FontAwesomeIcon
                                className="group-hover:!text-[#BE123C] text-xl sm:text-2xl md:text-[23px]"
                                icon={faTrashAlt}
                                style={{ color: "#000" }}
                              />
                            </button>
                          )}
                        </div>


                        <input
                          type="text"
                          name="service_title"
                          placeholder="Enter here"
                          defaultValue={service.title}
                          //   value={service.title}
                          onBlur={(e) => changeTitle(e.target.value)}
                          className="w-full h-[50px] mb-4 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
                          required
                        />
                        <h3 className="mt-[30px] mb-[4px] font-bold">
                          Service Description and Your Experience
                        </h3>
                        <p className="mt-[7px] mb-[19px] text-[#a1a1a1]">
                          Tell us about your working experience
                        </p>
                        <textarea
                          type="text"
                          name="field"
                          placeholder="Enter here"
                          defaultValue={service.UserService.experience}
                          onBlur={e => changeExperience(e.target.value)}
                          //   value={service.UserService.experience}
                          className="w-full max-w-[915px] h-[178px] mb-4 p-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
                          required
                        />
                        <p className="mt-[30px] mb-[4px] font-bold">
                          What Will Receiver Get
                        </p>
                        <textarea
                          type="text"
                          name="field"
                          placeholder="Enter here"
                          defaultValue={service.UserService.detail}
                          className="w-full max-w-[915px] h-[178px] mb-4 p-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
                          onBlur={e => changeDetail(e.target.value)}
                          required
                        />
                        <h3 className="mt-[30px] mb-2 font-bold">
                          Select your service type.
                        </h3>
                        <div className="ml-2 mb-8 flex items-center text-lg">
                          <input
                            type="radio"
                            name="type"
                            className="mr-1"
                            value="virtual"
                            onClick={(e) => changeType(e.target.value)}
                            checked={service.type === "virtual"}
                            key={`virtual-${service.id}`}
                          />
                          <span className="mr-8">Virtual</span>
                          <input
                            type="radio"
                            name="type"
                            className="mr-1"
                            value="in-person"
                            onClick={(e) => changeType(e.target.value)}
                            checked={service.type === "in-person"}
                            key={`in-person-${service.id}`}
                          />
                          <span className="mr-8">In Person</span>
                          <input
                            type="radio"
                            name="type"
                            className="mr-1"
                            value="both"
                            onClick={(e) => changeType(e.target.value)}
                            checked={service.type === "both"}
                            key={`both-${service.id}`}
                          />
                          <span>Both</span>
                        </div>

                        <h3 className="ml-2 mb-2">Points Rate for Service</h3>
                        <div className="relative">
                          <input
                            type="number"
                            name="points_rate"
                            min={0}
                            ref={rateRef}
                            onChange={(e) => changeRate(e.target.value)}
                            value={service.UserService.rate || ""}
                            className="w-full h-12 mb-4 pl-4 border border-solid border-[#e9e9e9] outline-none rounded-[13px]"
                            style={{ MozAppearance: "textfield" }}
                            required
                            readOnly
                          />
                          <div className="flex absolute top-1.5 right-2">
                            {[5, 10, 15, 20].map((val) => (
                              <button
                                key={val}
                                type="button"
                                onClick={() => changeRate(val)}
                                className={`px-4 sm:px-5 py-2 mr-2.5 border border-solid rounded-full cursor-pointer transition-colors
                                  ${Number(service.UserService.rate) === val
                                    ? "bg-[#1CC300] text-white border-[#1CC300]"
                                    : "bg-transparent text-[#1CC300] border-[#1CC300] hover:bg-[#1CC300]/10"
                                  }`}
                              >
                                {val}
                              </button>
                            ))}
                          </div>
                        </div>

                        <div className="flex justify-between items-center max-w-[511px]">
                          <button
                            type="button"
                            onClick={updateServiceDetail}
                            className="block py-2 px-16  text-white bg-main border-none outline-none rounded-full transition-colors duration-300 hover:bg-[#2bef0a] focus:outline-none active:outline-none"
                          >
                            Save
                          </button>
                        </div>
                      </Item>
                      <Item id="portfolio-list" className="text-left">
                        <div className="flex">
                          <div className="basis-1/2">
                            <span>
                              <Checkbox
                                className="mr-1"
                                // defaultChecked={
                                //   service.UserService.requireWorkSamples
                                // }
                                checked={service.UserService.requireWorkSamples}
                                onChange={(e) =>
                                  changeFieldRequirement(
                                    "portfolio",
                                    e.target.checked
                                  )
                                }
                              />
                              Add Work Sample
                            </span>
                          </div>
                          <div className="basis-1/2">
                            <span>
                              <Checkbox
                                className="mr-1"
                                // defaultChecked={
                                //   service.UserService.requireCertifications
                                // }
                                checked={
                                  service.UserService.requireCertifications
                                }
                                onChange={(e) =>
                                  changeFieldRequirement(
                                    "certification",
                                    e.target.checked
                                  )
                                }
                              />
                              Add Certifications
                            </span>
                          </div>
                        </div>
                        {service.UserService.requireWorkSamples ? (
                          <>
                            <h3 className="mt-[40px] mb-[6px] font-bold text-center">
                              Work Samples
                            </h3>
                            <p className="mt-[7px] mb-[19px] text-[#a1a1a1] text-center">
                              Update your work samples
                            </p>
                            <PortfolioImageUpload
                              items={portfolioList}
                              setter={setPortfolioList}
                              serviceId={service.UserService.id}
                            />
                          </>
                        ) : (
                          <></>
                        )}
                      </Item>
                      <Item id="certification-list" className="text-left">
                        {service.UserService.requireCertifications ? (
                          <>
                            <h3 className="mt-[60px] mb-[6px] font-bold text-center">
                              Professional Certifications
                            </h3>
                            <p className="mt-7px] mb-[19px] text-[#a1a1a1] text-center">
                              Update your Licenses, certifications, etc
                            </p>
                            <CertificationImageUpload
                              items={certificationList}
                              setter={setCertificationList}
                              serviceId={service.UserService.id} />
                          </>
                        ) : (
                          <></>
                        )}
                      </Item>
                    </Stack>
                  </div>
                </TabPanel>
              ))
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
